import { useRouter } from "@tanstack/react-router";

import { useUsageContext } from "@/react/providers/UsageContext/UsageContext";

// Account-profile onboarding shares the settings prefix but is not an admin area.
const SETTINGS_PATH_EXCEPTIONS = ["/settings/profile"];

const isSettingsAdminPath = (pathname: string) =>
  pathname.startsWith("/settings") &&
  SETTINGS_PATH_EXCEPTIONS.every(
    path => pathname !== path && !pathname.startsWith(`${path}/`),
  );

export const useIsAdminArea = () => {
  const { isAdminUsageContext } = useUsageContext();

  // This hook also runs outside RouterProvider, so router may not exist
  const router = useRouter({ warn: false });

  // Handle post modal (when viewing from the inbox notifications) routes, as
  // they change the browser URL but not the internal router state. That is
  // why maskedLocation is verified.
  const location = router?.stores.location.get();
  const pathname = location?.maskedLocation
    ? location.pathname
    : window.location.pathname;

  return Boolean(isAdminUsageContext) || isSettingsAdminPath(pathname);
};
